import { useEffect, useState } from "react";
import { Search } from "lucide-react";
import { useSearchParams } from "react-router-dom";
import { api } from "../api";
import { track } from "../analytics";
import { LoadingRows, PageState, PosterCard, TitleDialog } from "../components/Media";
import type { Title } from "../types";

export function SearchPage() {
  const [params] = useSearchParams();
  const query = params.get("q")?.trim() ?? "";
  const [results, setResults] = useState<Title[] | null>(null);
  const [selected, setSelected] = useState<Title | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (query.length < 2) {
      setResults([]);
      return;
    }
    setResults(null);
    setError(null);
    api<{ results: Title[] }>(`/v1/catalog/search?q=${encodeURIComponent(query)}`)
      .then((response) => {
        setResults(response.results);
        track("search_completed", { query_length: query.length, result_count: response.results.length });
      })
      .catch((searchError) => setError(searchError instanceof Error ? searchError.message : "Search failed."));
  }, [query]);

  if (error) return <PageState title="Search paused" message={error} />;
  return (
    <div className="standard-page search-page">
      <div className="page-heading">
        <p className="eyebrow">찾아보기 · Search</p>
        <h1>{query ? <>Results for “{query}”</> : "Find your next story"}</h1>
        <p>Only Korean dramas and films are included.</p>
      </div>
      {results === null ? <LoadingRows /> : results.length > 0 ? (
        <div className="poster-grid">
          {results.map((title) => <PosterCard key={title.id} title={title} onOpen={setSelected} />)}
        </div>
      ) : (
        <div className="inline-empty"><Search size={26} /><h2>No Korean titles found</h2><p>Try a Korean or English title, actor, or a shorter phrase.</p></div>
      )}
      {selected && <TitleDialog title={selected} onClose={() => setSelected(null)} />}
    </div>
  );
}
